import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Layout de /admin/ops — NO renderiza un sidebar propio.
 * El layout padre (admin.tsx) ya envuelve las rutas ops con PlatformAdminShell,
 * manteniendo el menú admin general visible. Acá sólo pasamos el contenido.
 */
export const Route = createFileRoute("/admin/ops")({
  component: () => <Outlet />,
});
